import { Button, Col, Container, Image, Row } from "react-bootstrap";

import React from "react";

export const Footer = () => {

	const styleScrittaAgu = {
		maxHeight: "20vh",
		padding: 0,
		margin: 0,
	};
	const styleReset = { padding: '0', margin: '0' }
	return (
		<Container fluid className="footer" style={{ padding: '0', margin: '0' }}>
			<Row style={{...styleReset,  padding: '2vh 0 0 0'}}>
				<Col sm={3} className="text-center" >
					<div className="footer-left" style={{ padding: '0vh' }}>
						<Image src='/images/logo.png' style={styleScrittaAgu} />
					</div>
				</Col>
				<Col sm={6} className=" text-center" style={{ padding: '5vh 5vh 0 5vh' }}>
					<div className="footer-center">
						<h4>Azienda Agricola Agù Andrea Costanzo</h4>
						<p>
							Via San Defendente, n 42 - 12031 Bagnolo Piemonte, Cuneo, Italy.
						</p>
						<p>
							Andrea: +39 3889428853  Email: info@cantinaagu.it
						</p>

					</div>
				</Col>
				<Col sm={3} className="text-center">
					<div className="footer-right" style={{ padding: '0vh' }}>
						<Image src='/images/Italia.png' style={styleScrittaAgu} />
					</div>
				</Col>
			</Row>
			<Row className="text-center">
				<Col sm={12}>
					<Button
						variant="link"
						href="/en/privacy"
						className="text-secondary"
					>
						Privacy
					</Button> |
					<Button
						variant="link"
						href="/en/cookie"
						className="text-secondary"
					>
						Cookie
					</Button>
				</Col>
			</Row>
			<Row style={styleReset}>
				<Col sm={12} style={styleReset}>
					<div className="footer-bottom text-center" style={{ backgroundColor: 'black', color: 'white', }}>
						<p style={styleReset}>Copyright &copy; {new Date().getFullYear()} Cantina Agù. All rights reserved.</p>
					</div>
				</Col>
			</Row>
		</Container>
	);
};
